import { render, staticRenderFns } from "./JImageGallery.vue?vue&type=template&id=50e6fb5a&scoped=true"
import script from "./JImageGallery.vue?vue&type=script&lang=ts"
export * from "./JImageGallery.vue?vue&type=script&lang=ts"
import style0 from "./JImageGallery.vue?vue&type=style&index=0&id=50e6fb5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6fb5a",
  null
  
)

export default component.exports